import Box from 'ui/src/components/Box'
import { useNavigate } from 'react-router-dom'
import { SwitchNotificationType } from './switchNotificationType'
import { INotification } from 'models/notification.model'
import Typography from 'ui/src/components/Typography'
import { fr, enUS } from 'date-fns/locale'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

interface ICard {
  notification: INotification
  setRefetchData: (boolean) => void
  updateNotification: (_id: string, isRead: boolean) => Promise<INotification>
  setIsNotificationsOpen: (bolean) => void
  score: number | undefined
  responsePlanRedirect: string
}

const Card = ({
  notification,
  setIsNotificationsOpen,
  updateNotification,
  setRefetchData,
  score,
  responsePlanRedirect,
}: ICard) => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const { isRead, notificationType: type, data: notificationData, _id, createdAt } = notification

  const NOTIFICATION_TYPE_ENUM = {
    DOMAIN: 'DOMAIN',
    PASSWORD: 'PASSWORD',
    ADDRESS: 'ADDRESS',
    MFA: 'MFA',
    SCORE: 'SCORE',
    SAFE: 'SAFE',
    IMAGE: 'IMAGE',
    NAME: 'NAME',
    PHONE: 'PHONE',
    OTHER: 'OTHER',
    REPORT_STATUS: 'REPORT_STATUS',
    RESPONSE_PLAN: 'RESPONSE_PLAN',
    UNRESOLVED: 'UNRESOLVED',
    ANALYTICS: 'ANALYTICS',
    COMPANY_SCORE: 'COMPANY_SCORE',
    COMPANY_UPDATES: 'COMPANY_UPDATES',
  }

  const urlPicker = (type: string): string => {
    switch (type) {
      case NOTIFICATION_TYPE_ENUM.DOMAIN:
        return '/webDomain-leaks'
      case NOTIFICATION_TYPE_ENUM.PASSWORD:
        return '/email-leaks'
      case NOTIFICATION_TYPE_ENUM.ADDRESS:
        return '/address-leaks'
      case NOTIFICATION_TYPE_ENUM.MFA:
        return '/dashboard#critical'
      case NOTIFICATION_TYPE_ENUM.SCORE:
        return '/dashboard#score'
      case NOTIFICATION_TYPE_ENUM.SAFE:
        return '/dashboard#strength'
      case NOTIFICATION_TYPE_ENUM.IMAGE:
        return '/image-leaks'
      case NOTIFICATION_TYPE_ENUM.NAME:
        return '/name-leaks'
      case NOTIFICATION_TYPE_ENUM.PHONE:
        return '/phone-leaks'
      case NOTIFICATION_TYPE_ENUM.OTHER:
        return '/dashboard#important'
      case NOTIFICATION_TYPE_ENUM.REPORT_STATUS:
        return '/image-leaks'
      case NOTIFICATION_TYPE_ENUM.RESPONSE_PLAN:
        return responsePlanRedirect
      case NOTIFICATION_TYPE_ENUM.UNRESOLVED:
        return '/dashboard'
      case NOTIFICATION_TYPE_ENUM.ANALYTICS:
        return '/company/dashboard'
      case NOTIFICATION_TYPE_ENUM.COMPANY_SCORE:
        return '/company/dashboard#score'
      case NOTIFICATION_TYPE_ENUM.COMPANY_UPDATES:
        return '/company/dashboard'

      default:
        return '/'
    }
  }

  const handleClick = async () => {
    await updateNotification(_id, true)
    setRefetchData(prev => !prev)
    navigate(urlPicker(type))
    setIsNotificationsOpen(false)
  }

  const formattedDate = createdAt
    ? format(new Date(createdAt), 'MMMM d, yyyy - HH:mm', {
        locale: i18n.language === 'fr-FR' || i18n.language === 'fr-CA' ? fr : enUS,
      })
    : undefined

  return (
    <div
      onClick={handleClick}
      style={{
        width: '100%',
        minHeight: 86,
        display: 'flex',
        alignItems: 'center',
        padding: '.250000rem 1rem',
        margin: '0.625rem 0',
        cursor: 'pointer',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          width: '52px',
        }}
      >
        {
          SwitchNotificationType(
            type,
            notificationData?.leakCount,
            notificationData?.scanDate,
            notificationData?.scoreDifference,
            notificationData?.notificationScore,
            score,
            notificationData?.reportResolution,
            notificationData?.s3Url,
          ).icon
        }
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
          width: 260,
        }}
      >
        {
          SwitchNotificationType(
            type,
            notificationData?.leakCount,
            notificationData?.scanDate,
            notificationData?.scoreDifference,
            notificationData?.notificationScore,
            score,
            notificationData?.reportResolution,
          ).title
        }
        {
          SwitchNotificationType(
            type,
            notificationData?.leakCount,
            notificationData?.scanDate,
            notificationData?.scoreDifference,
            notificationData?.notificationScore,
            score,
            notificationData?.reportResolution,
          ).description
        }
        {createdAt && (
          <Typography
            variant="caption"
            sx={{
              color: 'gray.500',
            }}
          >
            {formattedDate}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          right: 0,
        }}
      >
        {!isRead && (
          <Box
            sx={{
              width: 0.3125,
              height: 0.3125,
              borderRadius: '50%',
              background: '#BE0027',
            }}
          />
        )}
      </Box>
    </div>
  )
}

export default Card
